import React from 'react';
import { BrainCircuitIcon, ZapIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-16 md:py-24 bg-slate-900 relative overflow-hidden" data-id="element-166">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-900/20 rounded-full blur-[100px] pointer-events-none" data-id="element-167" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-168">
        <div className="text-center mb-12" data-id="element-169">
          <div className="inline-flex items-center justify-center p-4 bg-blue-500/10 rounded-2xl mb-6 border border-blue-500/20" data-id="element-170">
            <BrainCircuitIcon className="w-12 h-12 text-blue-400" data-id="element-171" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-172">
            El Mecanismo Único: <br className="hidden md:block" data-id="element-173" />
            <span className="text-blue-400" data-id="element-174">Desactivación Vagotónica</span>
          </h2>
        </div>

        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 md:p-12 border border-slate-700 shadow-2xl" data-id="element-175">
          <p className="text-xl text-slate-300 leading-relaxed mb-8 text-center" data-id="element-176">
            La solución no está en tu mente, sino en tu biología. El Protocolo
            de Desactivación Vagotónica utiliza hacks físicos —temperatura,
            apnea controlada y anclaje somático— para forzar a tu nervio vago a
            disparar señales de seguridad directamente al tallo cerebral.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 p-6 bg-blue-950/30 rounded-xl border border-blue-900/50" data-id="element-177">
            <ZapIcon className="w-10 h-10 text-yellow-400 flex-shrink-0" data-id="element-178" />
            <p className="text-lg text-blue-100 font-medium leading-relaxed" data-id="element-179">
              No intentamos convencer a tu mente de que se calme; obligamos a tu
              cuerpo a relajarse químicamente, haciendo que el sueño sea la
              consecuencia inevitable de una biología en paz.
            </p>
          </div>
        </div>
      </div>
    </section>;
}